import React, { useState } from 'react'
import { Button, Tooltip } from 'antd'
import { Text } from '../../../../styles/reactnative'
import PCInfoModal from '../PCInfoModal'

interface PCInfoDetailCellProps {
	text: string
	record: any
}

const PCInfoDetailCell: React.FC<PCInfoDetailCellProps> = ({ text, record }) => {
	const [pcInfoVisible, setPcInfoVisible] = useState(false)

	// FR000 로그인 경우 PC 정보 보기 버튼 표시
	if (record?.log === 'FR000') {
		try {
			const parsed = JSON.parse(text)
			if (parsed?.system) {
				return (
					<>
						<Button
							size="small"
							type="link"
							onClick={() => setPcInfoVisible(true)}
							style={{ padding: 0 }}>
							PC정보 [보기]
						</Button>
						<PCInfoModal
							visible={pcInfoVisible}
							onClose={() => setPcInfoVisible(false)}
							data={text}
						/>
					</>
				)
			}
		} catch (e) {
			// JSON 파싱 실패 시 기본 표시
		}
	}

	// 기본 표시
	return (
		<Tooltip title={text} placement="left">
			<Text
				style={{
					fontSize: 8,
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					display: 'block',
					maxWidth: '50px',
				}}>
				{text}
			</Text>
		</Tooltip>
	)
}

export default PCInfoDetailCell
